import { FileText, StickyNote } from "lucide-react";
import { CANVAS_KEYS } from "../canvas-controls.config";
import { useCanvasToolbarLayout } from "../context/CanvasToolbarLayoutContext";
import {
  CanvasToolbarButton,
  CanvasToolbarGroup,
  CanvasToolbarShell,
} from "./toolbar";

interface NoteDocPopoverProps {
  onSelectNote: (screenPos: { x: number; y: number }) => void;
  onSelectDoc: (screenPos: { x: number; y: number }) => void;
}

/**
 * Note / Doc picker — same shell + button sizing as the primary toolbar.
 */
export function NoteDocPopover({
  onSelectNote,
  onSelectDoc,
}: NoteDocPopoverProps) {
  const { flyoutOrientation, tooltipSide } = useCanvasToolbarLayout();

  return (
    <CanvasToolbarShell
      orientation={flyoutOrientation}
      aria-label="Note or doc"
    >
      <CanvasToolbarGroup orientation={flyoutOrientation}>
        <CanvasToolbarButton
          label={
            <>
              Note{" "}
              <kbd className="ml-1 rounded border border-current/40 px-1 py-px text-[10px] leading-none">
                {CANVAS_KEYS.addNote.toUpperCase()}
              </kbd>
            </>
          }
          tooltipSide={tooltipSide}
          aria-label="Add note"
          onClick={(e) => onSelectNote({ x: e.clientX, y: e.clientY })}
        >
          <StickyNote className="size-4" strokeWidth={2} />
        </CanvasToolbarButton>

        <CanvasToolbarButton
          label={
            <>
              Doc{" "}
              <kbd className="ml-1 rounded border border-current/40 px-1 py-px text-[10px] leading-none">
                {CANVAS_KEYS.addDoc.toUpperCase()}
              </kbd>
            </>
          }
          tooltipSide={tooltipSide}
          aria-label="Add doc"
          onClick={(e) => onSelectDoc({ x: e.clientX, y: e.clientY })}
        >
          <FileText className="size-4" strokeWidth={2} />
        </CanvasToolbarButton>
      </CanvasToolbarGroup>
    </CanvasToolbarShell>
  );
}
